<div *ngIf="user">
  <div
    class="flex grid-gap-15 p-2"
    style="background-color: #fff; border-radius: 12px; border: 1px solid #bdbdbd"
  >
    <div class="avatar-container">
      <p-avatar
        *ngIf="user.profileImageUrl"
        shape="circle"
        styleClass="xxlarge"
        [image]="user.profileImageUrl"
      ></p-avatar>

      <span class="grey-circle" *ngIf="!user.profileImageUrl">
        <i class="fa fa-camera"></i>
      </span>
    </div>
    <div style="width: 100%; align-self: center">
      <div style="font-size: 24px; font-weight: 600">{{ user.firstName }} {{ user.lastName }}</div>
      <div style="margin-top: 7px">
        <i class="fa fa-phone" style="color: #808080"></i
        ><span style="margin-left: 4px">{{ user.phoneNumber }}</span>
      </div>
      <div style="margin-top: 4px">
        <i class="fa fa-envelope" style="color: #808080"></i
        ><span style="margin-left: 4px">{{ user.email }}</span>
      </div>
      <div style="margin-top: 4px" *ngIf="userOrg">
        <i class="fa fa-home" style="color: #808080"></i
        ><span style="margin-left: 4px">{{
          userOrg.addressLine1 +
            ' ' +
            userOrg.addressLine2 +
            ' ' +
            userOrg.addressLine3 +
            ' ' +
            userOrg.postcode
        }}</span>
      </div>
    </div>
    <div style="cursor: pointer; text-align: end; white-space: nowrap" (click)="editProfile()">
      <span style="padding-right: 5px">edit</span><i class="fa fa-pencil"></i>
    </div>
  </div>
</div>

<p-dialog
  header="Edit profile details"
  [visible]="editProfileVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '650px' }"
  (visibleChange)="dialogVisibleChanged($event)"
>
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" *ngIf="userForm">
    <div style="display: flex; flex-direction: row">
      <div style="flex-shrink: 1; flex-basis: 200px; align-self: center; text-align: center">
        <div class="form-component">
          <p-fileUpload
            id="profile"
            name="files"
            url="/api/users/updateProfileImage"
            #pUploader
            (onBeforeUpload)="onBeforeProfileImageUpload($event)"
            (onUpload)="onProfileImageUpload($event)"
            (onSelect)="onSelectProfileImage($event)"
            (onError)="onProfileImageUploadError($event)"
            [showUploadButton]="false"
            withCredentials="true"
            [showCancelButton]="false"
            [maxFileSize]="83886080"
            accept="application/pdf,image/*"
            hidden="hidden"
          >
          </p-fileUpload>

          <div class="grey-circle" *ngIf="!user?.profileImageUrl" (click)="UploadFile()">
            <i class="fa fa-camera"></i>
          </div>
          <div *ngIf="user?.profileImageUrl" (click)="UploadFile()">
            <p-avatar shape="circle" styleClass="xxlarge" [image]="user.profileImageUrl"></p-avatar>
          </div>
        </div>
      </div>
      <div style="flex-grow: 1; flex-basis: 250px">
        <div class="grid">
          <div class="col-4">First Name:</div>
          <div class="col-8">
            <input
              pInputText
              id="firstname"
              formControlName="firstname"
              maxlength="32"
              class="form-component"
            />
          </div>

          <div class="col-4">Last Name:</div>
          <div class="col-8">
            <input
              pInputText
              id="lastname"
              formControlName="lastname"
              maxlength="32"
              class="form-component"
            />
          </div>

          <div class="col-4">Email:</div>
          <div class="col-8">
            <input
              pInputText
              id="email"
              formControlName="email"
              maxlength="254"
              class="form-component"
            />
          </div>

          <div class="col-4">Number:</div>
          <div class="col-8">
            <input
              pInputText
              id="number"
              formControlName="phoneNumber"
              maxlength="20"
              class="form-component"
            />
          </div>
        </div>

        <!-- User Org form (address) -->
        <form [formGroup]="userOrgForm" (ngSubmit)="onSubmit()" *ngIf="userOrgForm">
          <div class="grid" style="margin-top: 0 !important">
            <div class="col-4">Address 1:</div>
            <div class="col-8">
              <input
                pInputText
                id="address1"
                formControlName="addressLine1"
                maxlength="60"
                class="form-component"
              />
            </div>

            <div class="col-4">Address 2:</div>
            <div class="col-8">
              <input
                pInputText
                id="address2"
                formControlName="addressLine2"
                maxlength="60"
                class="form-component"
              />
            </div>

            <div class="col-4">Address 3:</div>
            <div class="col-8">
              <input
                pInputText
                id="address3"
                formControlName="addressLine3"
                maxlength="60"
                class="form-component"
              />
            </div>

            <div class="col-4">Postcode:</div>
            <div class="col-8">
              <input
                pInputText
                id="postcode"
                formControlName="postcode"
                maxlength="12"
                class="form-component"
              />
            </div>
          </div>
        </form>
      </div>
    </div>

    <div style="display: flex; grid-gap: 15px; justify-content: flex-end; margin-top: 10px">
      <div style="width: 68px; text-align: center; line-height: 31px">
        <span class="cancel-button" (click)="editProfileVisible = false"> Cancel </span>
      </div>
      <div style="flex-shrink: 1">
        <button
          pButton
          label="Save Changes"
          type="submit"
          [disabled]="userForm.invalid"
          icon="fa fa-check"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
